import { FILTERS, FILTERS_NAME } from '../constants/filters';
import { IRouterQuery } from '../interfaces/routes';

export const generateQueryFromFilters = (filters: FILTERS): IRouterQuery => {
  const query = {
    ...filters,
    ...(filters.isAscSorting && { [FILTERS_NAME.IS_ASC_SORTING]: filters.isAscSorting.toString() }),
    ...(filters.reviewTag && { [FILTERS_NAME.REVIEW_TAG]: filters.reviewTag.key }),
    ...(filters.productCategoryByPerson && { productCategory: filters.productCategoryByPerson }),
  };

  delete query[FILTERS_NAME.PRODUCT_CATEGORY_BY_PERSON];

  return query;
};

export const generatePlainFilters = (filters: FILTERS): FILTERS<string, string> => {
  return {
    ...filters,
    ...(filters.isAscSorting && { [FILTERS_NAME.IS_ASC_SORTING]: filters.isAscSorting.toString() }),
    ...(filters.reviewTag && { [FILTERS_NAME.REVIEW_TAG]: filters.reviewTag.key }),
  };
};
